// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'rijksFont', 'rijksFont Fallback', Tahoma, sans-serif"},"className":"__className_99240a"};